import { APP_IDS, type FeedbackInput } from '@feedback-service/shared';

type AppId = FeedbackInput['appId'];

export function isValidAppId(appId: string): appId is AppId {
  return APP_IDS.some((app) => app.value === appId);
}
